import { Route, Switch, useHistory } from "react-router-dom";
import React, { useEffect } from "react";
import { LoginCallback } from "@okta/okta-react";
import { isActiveLink } from "types";
import { AxiosRequestConfig } from "axios";
import { useAuth, usePermissions, useMisbilledTrades } from "../../hooks";
import { PermissionsEnum } from "../../constants";
import AppLayout from "../AppLayout";
import { PermissionRoute } from "../../components/PermissionRoute";
import { ApexLogin } from "../ApexLogin";
import { RoutesEnum } from "../../types/RoutesEnum";
import { links } from "../../utils";
import MismatchedPage from "../MismatchedPage/MismatchedPage";
import MisbilledPage from "../MisbilledPage/MisbilledPage";

export const App = () => {
  const { showAppContent, handleSignOut, authToken } = useAuth();
  const history = useHistory();
  const { hasPermission, permissionsLoading } = usePermissions();
  const canRead = hasPermission(PermissionsEnum.AccountRead);
  const { getMisbilledTrades, misbilledRecordState } = useMisbilledTrades();

  useEffect(() => {
    const {
      location: { pathname },
    } = history;

    if (!permissionsLoading && canRead && pathname === "/") {
      history.replace(`/${RoutesEnum.Home}`);
    }
  }, [permissionsLoading, canRead, history, history.location.pathname]);

  const occBalancingPermissions = [PermissionsEnum.AccountRead];
  const dateTime = new Date().toISOString().substring(0, 19);

  const config: AxiosRequestConfig = {
    headers: {
      Authorization: authToken === "null" ? "" : authToken,
    },
  };

  useEffect(() => {
    if (showAppContent) {
      getMisbilledTrades(dateTime, dateTime, config);
    }
  }, [showAppContent]);

  return (
    <AppLayout
      includeHeader
      isActiveLink={isActiveLink}
      links={links}
      logout={handleSignOut}
      showLogout={showAppContent}
    >
      {showAppContent ? (
        <>
          <Route path="/" component={LoginCallback} />
          <Switch>
            <PermissionRoute
              path="/mismatched"
              component={MismatchedPage}
              requiredPermissions={occBalancingPermissions}
            />
            <PermissionRoute
              path="/misbilled"
              requiredPermissions={occBalancingPermissions}
            >
              <MisbilledPage records={misbilledRecordState.records} />
            </PermissionRoute>
          </Switch>
        </>
      ) : (
        <ApexLogin />
      )}
    </AppLayout>
  );
};
